export default "__VITE_ASSET__080c513b__"